<label i18n="Categories Label@@creativeUnitPackageCategoryPickerCategoriesLabel">Categories:</label>
<div *ngFor="let category of categories" class="pt-2 row flex">
	<div class="col mr-3">{{ category.name }}</div>
	<div class="col input">
		<app-multiselect-input
			[options]="category.values"
			[currentValue]="getCategory(category.id)?.values"
			[fullWidth]="true"
			(valueChange)="setCategoryValues(category.id, $event)"
		></app-multiselect-input>
	</div>
</div>
